module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dofMarquee",
    staticClass: "dof-marquee weex-ct weex-div",
    style: (_vm._px2rem(_vm.wrapStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.direction === 'row') ? _c('div', {
    staticClass: "wrap weex-ct weex-div",
    style: (_vm._px2rem(_vm.baseStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "marquee1",
    staticClass: "marquee1 weex-ct weex-div",
    style: (_vm._px2rem(_vm.marquee1, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "dof-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _c('div', {
    ref: "marquee2",
    staticClass: "marquee2 weex-ct weex-div",
    style: (_vm._px2rem(_vm.marquee2, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "dof-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.text))])])]) : _vm._e(), _vm._v(" "), (_vm.direction === 'column') ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.baseStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "wrapColumn",
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.baseStyleWrap, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._l((_vm.text), function(txt) {
    return _c('p', {
      staticClass: "text-item weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.textStyle, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(txt))])
  }), _vm._v(" "), _c('p', {
    staticClass: "text-item weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(this.text[0]))])], 2)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-31ac195d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31ac195d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-marquee/index.vue
// module id = 597
// module chunks = 0 1